"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgAttachmentOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M27 17.61L14.4 5A6.65 6.65 0 005 14.4l.3.31 1.42-1.42L6.4 13a4.68 4.68 0 010-6.59A4.67 4.67 0 0113 6.4L25.61 19A4.66 4.66 0 0119 25.61l-7.31-7.32a2.51 2.51 0 010-3.56 2.55 2.55 0 013.54 0l5 5 1.4-1.42-5-5a4.49 4.49 0 00-6.36 0 4.53 4.53 0 000 6.39l7.34 7.3A6.65 6.65 0 0027 17.61z" })));
}
exports.default = SvgAttachmentOutline;
//# sourceMappingURL=AttachmentOutline.js.map